import { ChangePasswordData } from "approot/global/components/changepassword/common.changepassword.service";
import { BaseRepository } from "approot/global/repository/baseRepository";

export class ExternalChangePasswordRepository extends BaseRepository {
	jwtTokenValidate(jwtKey: string): Promise<void> {
		return this.$http.post("/webapi/external/validation", null, { params: { jwtKey: jwtKey } })
			.then(this.handleResponse);
	}

	getChangePasswordData(jwtKey: string): Promise<ChangePasswordData> {
		return this.$http.get("/webapi/external/password-data", { params: { jwtKey: jwtKey } })
			.then(this.handleResponse);
	}

	changePassword(jwtKey: string, password: string): Promise<void> {
		let request = {
			jwtKey: jwtKey,
			password: password
		};
		return this.$http.post("/webapi/external/change-password", request)
			.then(this.handleResponse);
	}
}